import React from 'react';
import {ReactComponent as TableFilter} from "../../../../../../asset/icons/tableFiltericon.svg";
import {useTranslation} from "react-i18next";

function DetailStatusFilterBase({value, onChange}) {
  const {t} = useTranslation()

  return (
    <div className='detail-status-search-base'>
      <div className='detail-status-filter-box'>
        <TableFilter/>
      </div>
      <select
        value={value}
        placeholder="test"
        className="detail-status-select-filter"
        onChange={onChange}>
        <option selected disabled>{t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.select.placeholder')}</option>
        <option value="username">{t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.select.username')}</option>
        <option value="user_phone_number">{t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.select.phoneNumber')}</option>
        <option value="code">{t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.select.code')}</option>
      </select>
    </div>
  );
}

export default DetailStatusFilterBase;
